export default __webpack_public_path__ + "static/media/image3.2c1e03e1.jpg";